module.exports = __webpack_public_path__ + "static/media/README.d8aa4dd1.md";